import { render, staticRenderFns } from "./ActionAccessControl.vue?vue&type=template&id=3870de54&"
import script from "./ActionAccessControl.vue?vue&type=script&lang=ts&"
export * from "./ActionAccessControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports